export const range = (start, end) => {
  return [...Array(end - start + 1)].map((_, i) => start + i);
};
